import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Notification {
  ID: number;
  Description: string;
  Type: string;
  Title: string;
  UID: number;
  Read: string;
  createdAt: string;
  updatedAt: string;
}

interface NotificationsState {
  notifications: Notification[];
  count: number | null;
}
const initialState: NotificationsState = {
  notifications: [],
  count: null,
};
const NotificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    GetNotifications(state, action: PayloadAction<Notification[]>) {
      state.notifications = action.payload;
    },
    GetNotificationsLength(state, action: PayloadAction<number>) {
      state.count = action.payload;
    },
    GetNewNotifications(state, action: PayloadAction<Notification[]>) {
      // state.notifications = [...action?.payload, ...state?.notifications];
      const newNotifications = Array.isArray(action.payload) ? action.payload : [];
      state.notifications = [...newNotifications, ...state.notifications];
      const uniqueNotifications = new Map();
      state.notifications.forEach((notification) => {
        uniqueNotifications.set(notification.ID, notification);
      });
      state.notifications = Array.from(uniqueNotifications.values());
    },
    ReadNewNotifications(state, action: PayloadAction<number>) {
      state.notifications = state.notifications.map((notification) =>
        notification.ID === action.payload
          ? { ...notification, Read: "Y" }
          : notification
      );
      const uniqueNotifications = new Map();
      state.notifications.forEach((notification) => {
        uniqueNotifications.set(notification.ID, notification);
      });
      state.notifications = Array.from(uniqueNotifications.values());
    },
    ReadAllNewNotifications(state, action: PayloadAction<number>) {
      state.notifications = state.notifications.map((notification) => ({
        ...notification,
        Read: "Y",
      }));
    },
  },
});
export default NotificationsSlice.reducer;
export const {
  GetNotifications,
  GetNotificationsLength,
  GetNewNotifications,
  ReadNewNotifications,
  ReadAllNewNotifications,
} = NotificationsSlice.actions;
